// Home / hero section content.
module.exports = {
  welcome: "Welcome",
  typewriter: [
    "I'm Will Laws.",
    "I'm a Technology Leader.",
    "I'm a Solutions Architect.",
    "I'm 12x AWS Certified.",
    "I'm a re:Invent Speaker.",
    "I'm a Founder.",
    "I'm a Trusted Advisor.",
    "I'm a Blogger.",
  ],
  location: "based in Sydney, Australia.",
  ctaText: "Get in Touch",
};
